export const statusConfig = {
  order_placed: {
    label: 'მოთხოვნა დაფიქსირებულია',
    icon: 'fas fa-file-alt',
    shortLabel: 'დაფიქსირდა',
  },
  processing: {
    label: 'გასაცემად მზადება',
    icon: 'fas fa-box-open',
    shortLabel: 'მზადება',
  },
  shipped: {
    label: 'საწყობიდან გაიცა',
    icon: 'fas fa-warehouse',
    shortLabel: 'გაიცა',
  },
  delivering: {
    label: 'ტრანსპორტირება',
    icon: 'fas fa-truck',
    shortLabel: 'ტრანსპორტში',
  },
  completed: {
    label: 'შეკვეთა ჩაბარებულია',
    icon: 'fas fa-check-circle',
    shortLabel: 'ჩაბარდა',
  },
  canceled: {
    label: 'გაუქმებულია',
    icon: 'fas fa-times-circle',
    shortLabel: 'გაუქმდა',
  },
  no_answer: {
    label: 'ვერ გიკავშირდებით',
    icon: 'fas fa-phone-slash',
    shortLabel: 'ვერ დაკავშირება',
  },
  awaiting_payment: {
    label: 'ელოდება გადახდას',
    icon: 'fas fa-hourglass-half',
    shortLabel: 'გადახდის მოლოდინი',
  },
}

export const specialStatusKeys = ['canceled', 'no_answer', 'awaiting_payment']
